function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fred_hutch_svg__cls-1{fill:#88c540}.fred_hutch_svg__cls-2{fill:#1c7b7e}.fred_hutch_svg__cls-3{fill:#35b5b9}.fred_hutch_svg__cls-4{fill:#1c3a62}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__svg3705"
}, /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__layer1"
}, /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g230"
}, /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g232"
}, /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g238"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path240",
  className: "fred_hutch_svg__cls-1",
  d: "M0 18.46a18.43 18.43 0 001.16 6.44l3-8.16a2.19 2.19 0 00-3.7-2.2A18.49 18.49 0 000 18.46"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g242"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path244",
  className: "fred_hutch_svg__cls-2",
  d: "M3.18 12.92A2.2 2.2 0 006 11.61l3.33-9.19a18.54 18.54 0 00-7.57 8.18 2.2 2.2 0 001.42 2.31"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g246"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path248",
  className: "fred_hutch_svg__cls-3",
  d: "M29.27 26.94A2.19 2.19 0 1128 24.13a2.19 2.19 0 011.31 2.81"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g250"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path252",
  className: "fred_hutch_svg__cls-1",
  d: "M26.53 34.45a2.19 2.19 0 11-4.12-1.5l.87-2.38a2.19 2.19 0 114.12 1.5z"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g254"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path256",
  className: "fred_hutch_svg__cls-1",
  d: "M31.13 21.81a2.19 2.19 0 11-4.13-1.5l3.8-10.4a2.19 2.19 0 114.12 1.5z"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g258"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path260",
  className: "fred_hutch_svg__cls-2",
  d: "M36.93 18.46a18.43 18.43 0 00-1.14-6.4l-2.54 7a2.19 2.19 0 003.43 2.45 18.46 18.46 0 00.25-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g262"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path264",
  className: "fred_hutch_svg__cls-3",
  d: "M35.57 25.4a2.19 2.19 0 00-4.2-1.23l-3.75 10.32a18.52 18.52 0 008-9.09"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g266"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path268",
  className: "fred_hutch_svg__cls-1",
  d: "M22.83 12.91a2.19 2.19 0 11-4.12-1.5l3.29-9a2.19 2.19 0 114.12 1.5z"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g270"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path272",
  className: "fred_hutch_svg__cls-1",
  d: "M17.4 21.42a2.19 2.19 0 00-2.81 1.31l-4.45 12.21a18.34 18.34 0 004.12 1.5l4.45-12.21a2.19 2.19 0 00-1.31-2.81"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g274"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path276",
  className: "fred_hutch_svg__cls-1",
  d: "M11.19 6.77A2.2 2.2 0 0014 5.46L15.92.18a18.36 18.36 0 00-5.22 1.53L9.88 4a2.2 2.2 0 001.31 2.81"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g278"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path280",
  className: "fred_hutch_svg__cls-3",
  d: "M12.14 10.59a2.19 2.19 0 11-1.31-2.81 2.19 2.19 0 011.31 2.81"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g282"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path284",
  className: "fred_hutch_svg__cls-3",
  d: "M6.29 20.23A2.2 2.2 0 015 17.43L2 25.6a2.19 2.19 0 004.12 1.5l3-8.18a2.2 2.2 0 01-2.81 1.31"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g286"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path288",
  className: "fred_hutch_svg__cls-1",
  d: "M9.1 18.92a2.19 2.19 0 01-4.1-1.5l1.17-3.21a2.19 2.19 0 014.12 1.5z"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g290"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path292",
  className: "fred_hutch_svg__cls-2",
  d: "M30.66 7.24l.72-2a18.48 18.48 0 00-3.65-2.78l-1.18 3.28a2.19 2.19 0 004.12 1.5"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g294"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path296",
  className: "fred_hutch_svg__cls-3",
  d: "M18.46 36.93c.48 0 .95 0 1.42-.06l.46-1.28a2.19 2.19 0 10-4.12-1.5l-.93 2.56a18.52 18.52 0 003.17.28"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g298"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path300",
  className: "fred_hutch_svg__cls-4",
  d: "M22.22 30.44a2.19 2.19 0 01-4.12-1.5l6.58-18.08a2.19 2.19 0 014.12 1.5z"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g302"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path304",
  className: "fred_hutch_svg__cls-3",
  d: "M17.08.06a2.2 2.2 0 001.37 2.62 2.2 2.2 0 002.81-1.31l.39-1.09A18.5 18.5 0 0018.46 0c-.47 0-.93 0-1.38.06"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g306"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path308",
  className: "fred_hutch_svg__cls-2",
  d: "M9.22 34.44l2.27-6.23a2.19 2.19 0 01-4.12-1.51l-1.81 5a18.54 18.54 0 003.66 2.78"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g310"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path312",
  className: "fred_hutch_svg__cls-1",
  d: "M11.49 28.2a2.19 2.19 0 11-1.31-2.81 2.19 2.19 0 011.31 2.81"
})), /*#__PURE__*/React.createElement("g", {
  id: "fred_hutch_svg__g314"
}, /*#__PURE__*/React.createElement("path", {
  id: "fred_hutch_svg__path316",
  className: "fred_hutch_svg__cls-4",
  d: "M19.48 15.25a2.65 2.65 0 00-1.32-.13c-.58.07-1.83 0-1.24-1.81l2.5-6.87a2.19 2.19 0 00-4.12-1.5L9.23 21.61a2.19 2.19 0 004.12 1.5l1.1-3c.75-1.8 1.73-1 2.12-.58a2.67 2.67 0 102.92-4.27"
})))))));

function SvgFredHutch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36.93 36.93"
  }, props), _ref, _ref2);
}

export default "assets/fred_hutch.cc92fa6.svg";
export { SvgFredHutch as ReactComponent };